import 'cookieconsent';
import 'cookieconsent/build/cookieconsent.min.css';
import { getCookie, setCookie, deleteCookie } from '../../lib/cookie-helpers';
import cookieData from './data';

const CookieConsent = () => {
  const documentLang = document.documentElement.lang;
  const cookieLang = getCookie('lang');

  if (cookieLang !== documentLang) {
    deleteCookie('lang');
    setCookie('lang', documentLang, 365);
  }

  // Docs at https://cookieconsent.insites.com/documentation/
  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: '#fffffff7',
      },
      button: {
        background: 'transparent',
        text: '#000000',
        border: '#000000',
      },
    },
    elements: {
      dismiss:
        '<a aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss btn border border-black btn--color-black mb-none">{{dismiss}}</a>',
    },
    content: cookieData[documentLang],
  });
};

export default CookieConsent;



// WEBPACK FOOTER //
// ./src/scripts/modules/CookieConsent/index.js